import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TOWNS } from '../constants/towns';
import './Settings.css';

const SETTINGS_KEY = 'rec_user_settings_v1';

type UserSettings = {
  defaultTown: string;
  compactCalendar: boolean;
  showDemandHints: boolean;
};

const defaultSettings: UserSettings = {
  defaultTown: 'regional',
  compactCalendar: false,
  showDemandHints: true,
};

function loadSettings(): UserSettings {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return defaultSettings;
    return { ...defaultSettings, ...(JSON.parse(raw) as Partial<UserSettings>) };
  } catch {
    return defaultSettings;
  }
}

export default function Settings() {
  const [settings, setSettings] = useState<UserSettings>(loadSettings);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    setSaved(true);
    const t = window.setTimeout(() => setSaved(false), 1200);
    return () => window.clearTimeout(t);
  }, [settings]);

  return (
    <div className="settings-page">
      <header className="settings-head">
        <p>Settings</p>
        <h1>Dashboard and planner preferences</h1>
        <Link to="/dashboard">Back to dashboard</Link>
      </header>

      <section className="settings-card">
        <label>
          <span>Default town</span>
          <select
            value={settings.defaultTown}
            onChange={(e) => setSettings((prev) => ({ ...prev, defaultTown: e.target.value }))}
          >
            {TOWNS.map((town) => (
              <option key={town.slug} value={town.slug}>
                {town.name}
              </option>
            ))}
          </select>
        </label>

        <label className="settings-toggle">
          <input
            type="checkbox"
            checked={settings.compactCalendar}
            onChange={(e) => setSettings((prev) => ({ ...prev, compactCalendar: e.target.checked }))}
          />
          <span>Use compact calendar density</span>
        </label>

        <label className="settings-toggle">
          <input
            type="checkbox"
            checked={settings.showDemandHints}
            onChange={(e) => setSettings((prev) => ({ ...prev, showDemandHints: e.target.checked }))}
          />
          <span>Show demand hints in Your Year Ahead planner</span>
        </label>

        <p className="settings-status">{saved ? 'Saved' : ' '}</p>
      </section>
    </div>
  );
}
